import { Injectable } from "@angular/core";
import { HttpClient } from "@angular/common/http";
import { environment } from "@environments/environment";

@Injectable({
  providedIn: "root",
})
export class GopherService {
  constructor(private http: HttpClient) {}

  getClientsById(id) {
    return this.http.get<any>(`${environment.apiUrl}gopher/client`, {
      params: { projectId: id },
    });
  }

  syncClient(id) {
    return this.http.get<any>(`${environment.apiUrl}gopher/client/${id}/sync`);
  }

  deleteClient(id) {
    return this.http.delete<any>(`${environment.apiUrl}gopher/client/${id}`);
  }

  save(formData) {
    return this.http.post<any>(`${environment.apiUrl}gopher/client`, formData);
  }

  getAttackresults(searchParams) {
    return this.http.post<any>(
      `${environment.apiUrl}gopher/attack/result`,
      searchParams
    );
  }

  saveAttack(formData) {
    return this.http.post<any>(`${environment.apiUrl}gopher/attack`, formData);
  }

  abort(id) {
    return this.http.get<any>(
      `${environment.apiUrl}gopher/attack/${id}/abort`
    );
  }

  getAttackDetails(id) {
    return this.http.get<any>(
      `${environment.apiUrl}gopher/attack/result/${id}`
    );
  }
}
